const MATCH_UUID = /([a-z\d]{8})-[a-z\d]{4}-[a-z\d]{4}-[a-z\d]{4}-([a-z\d]{12})/g

const replacer = (_: string, startPart: string, endPart: string): string =>
  `${startPart}-xxxx-xxxx-xxxx-${endPart}`

export const replaceUuids = (input: string): string => input.replace(MATCH_UUID, replacer)
